var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-2"},[(_vm.$store.state.main.loading)?_c('b-spinner',{staticClass:"wm-fc-2"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }